// extracted by mini-css-extract-plugin
export default {"alert":"varselCreateForm_alert__90lLw","actionButtons":"varselCreateForm_actionButtons__X28XG","link":"varselCreateForm_link__TOZx7"};